import * as React from 'react';
import { ContentView } from '@levelapp/softfabric';
import ButtonImportFileViewStyle from './ButtonImportFileViewStyle';
import ButtonImportFileViewModel from './ButtonImportFileViewModel';
import { Platform } from 'react-native';
export default class ButtonImportFileView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new ButtonImportFileViewModel(this), new ButtonImportFileViewStyle(this));
    }
    /* RENDERING */
    render() {
        if (Platform.OS == 'web') {
            var ButtonImportFileWeb = require('./buttonimportfileweb/ButtonImportFileWebView').default;
            return (React.createElement(ButtonImportFileWeb, { buttonColor: this.props.buttonColor, textColor: this.props.textColor, accepted: this.props.accepted, action: (file) => this.props.action(file) }));
        }
        else {
            var ButtonImportFileMobile = require('./buttonimportfilemobile/ButtonImportFileMobileView').default;
            return (React.createElement(ButtonImportFileMobile, null));
        }
    }
}
